import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";
import {TaskModel} from "../../../tasks/models/task.model";

export class quotesPerTaskSelectCtrl implements IController {

  task: TaskModel;
  quote: any;
  minFrom: any;
  addressZoneId: string;
  configZoneId: string;
  onTimeChange: Function;
  onDateSelect: Function;

  private selectedDate: any;
  private minDate: any;
  private maxDate: any;

  private from: any;
  private to: any;

  private minSelectedQuote: any;
  private maxSelectedQuote: any;
  public fromInputName: string;
  public toInputName: string;

  /* @ngInject */
  constructor(private moment) {
  }

  $onInit() {
    this.selectedDate = new Date(_.get(this.quote, 'startTime'));
    this.minDate = new Date(_.get(this.quote, 'startTime'));
    this.maxDate = new Date(_.get(this.quote, 'endTime'));

    this.from = _.get(this.quote, 'defaultStartTime');
    this.to = _.get(this.quote, 'defaultEndTime');

    this.minSelectedQuote = _.get(this.quote, 'startTime');
    this.maxSelectedQuote = this._sameDay(new Date(_.get(this.quote, 'endTime')), this.minDate) ?
      this.quote.endTime :
      this.moment(_.get(this.quote, 'startTime')).endOf('day').valueOf();


    if (this.task.taskSpec.purpose == 'Pickup') {
      this.fromInputName = 'pickupStartTime';
      this.toInputName = 'pickupEndTime'
    } else {
      this.fromInputName = 'dropoffStartTime';
      this.toInputName = 'dropoffEndTime';
    }
    // ctrl.maxSelectedQuote = ctrl.quote.endTime;
  };

  $onChanges(changes) {
    if (changes.quote && !changes.quote.isFirstChange()) {
      const current = changes.quote.currentValue;
      const previous = changes.quote.previousValue;

      if (current.id !== previous.id) {
        this.$onInit();
      }
    }
    if (changes.minFrom && !changes.minFrom.isFirstChange()) {
      const quoteMin = _.get(this.quote, 'startTime');
      this.minSelectedQuote = !this.minFrom ? quoteMin : (quoteMin < this.minFrom ? this.minFrom : quoteMin);
      // const currentValue = changes.minFrom.currentValue;
      // if (this.from < currentValue) {
      //   this.from = currentValue;
      // }
      // this.minSelectedQuote = currentValue;
    }
  };

  /////////////////////////////////////////////////

  dateChanged(selectedDate) {
    if (this.task.taskSpec.purpose === 'Pickup') {
      this.onDateSelect({selectedDate: selectedDate});
    } else {
      this.minSelectedQuote = this.moment(selectedDate).startOf('day').valueOf();
      this.maxSelectedQuote = this.moment(selectedDate).endOf('day').valueOf();

      // var from =  _sameDay(new Date(selectedDate), ctrl.minDate) ? moment(ctrl.minDate).startOf('day').valueOf() : moment(selectedDate).startOf('day').valueOf();
      const from = this.moment(selectedDate).startOf('day').valueOf();
      const to = this._sameDay(new Date(selectedDate), this.maxDate) ? this.moment(this.maxDate).valueOf() : this.moment(selectedDate).endOf('day').minute(45).second(0).millisecond(0).valueOf();
      this.onTimeChanged(from, to);
    }
  }

  onTimeChanged(from, to) {
    if (from && to) {
      this.from = from;
      this.to = to;
      this.task.taskSpec.notBefore = from;
      this.task.taskSpec.notAfter = to;
    }
    this.onTimeChange({from: from, to: to});
  }

  onFromTimeChange(from) {
    this.from = from;
    this.task.taskSpec.notBefore = from;
    this.onTimeChange({from: from, to: this.to})
  }

  onToTimeChange(to) {
    this.to = to;
    this.task.taskSpec.notAfter = to;
    this.onTimeChange({from: this.from, to: to})
  }

  _sameDay(d1, d2) {
    return d1.getFullYear() === d2.getFullYear() &&
      d1.getMonth() === d2.getMonth() &&
      d1.getDate() === d2.getDate();
  }

}

angular
  .module('bringoz.admin.orders')
  .component('quotesPerTaskSelect', {
    bindings: {
      task: '<',
      quote: '<',
      minFrom: '<?',
      addressZoneId: '<',
      configZoneId: '<',
      onTimeChange: '&',
      onDateSelect: '&'
    },
    template: require('./quotes-per-task-select.html').default,
    controller: quotesPerTaskSelectCtrl
  });
